import React, { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import axiosInstance from "../axiosInstance"; // Import axiosInstance
import "../pages/Service.css";

const formatDate = (date) => {
  if (!date) return "";
  const localDate = new Date(date);
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const day = String(localDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const Services = () => {
  const today = new Date();
  const savedDate1 = localStorage.getItem("date1");
  const savedDate2 = localStorage.getItem("date2");
  const [date1, setDate1] = useState(savedDate1 ? new Date(savedDate1) : today);
  const [date2, setDate2] = useState(savedDate2 ? new Date(savedDate2) : today);
  const [loading, setLoading] = useState(false);
  const [positionName, setPositionName] = useState("Unknown Position");
  const [totalCount, setTotalCount] = useState(0);
  const [completeCount, setCompleteCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [veryEasyCount, setVeryEasyCount] = useState(0);
  const [easyCount, setEasyCount] = useState(0);
  const [neutralCount, setNeutralCount] = useState(0);
  const [difficultCount, setDifficultCount] = useState(0);
  const [veryDifficultCount, setVeryDifficultCount] = useState(0);

  const fetchCount = async () => {
    setLoading(true);
    const adjustedDate2 = new Date(date2);
    adjustedDate2.setDate(adjustedDate2.getDate() + 1);

    const payload = {
      start_date: formatDate(date1),
      end_date: formatDate(adjustedDate2),
    };

    try {
      const response = await axiosInstance.post("/pifir/dashboard/", payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      const data = response.data;
      if (data?.total_count !== undefined) {
        setTotalCount(data.total_count);
        setCompleteCount(data.total_completed_count);
        setPendingCount(data.total_pending_count);
        setVeryEasyCount(data.very_easy_count);
        setEasyCount(data.easy_count);
        setNeutralCount(data.neutral_count);
        setDifficultCount(data.difficult_count);
        setVeryDifficultCount(data.very_difficult_count);

        localStorage.setItem("totalCount", data.total_count);
        localStorage.setItem("completeCount", data.total_completed_count);
        localStorage.setItem("pendingCount", data.total_pending_count);
        localStorage.setItem("veryEasyCount", data.very_easy_count);
        localStorage.setItem("easyCount", data.easy_count);
        localStorage.setItem("neutralCount", data.neutral_count);
        localStorage.setItem("difficultCount", data.difficult_count);
        localStorage.setItem("veryDifficultCount", data.very_difficult_count);
      } else {
        resetCounts();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      handleReset();
    } finally {
      setLoading(false);
    }
  };

  const resetCounts = () => {
    setTotalCount(0);
    setCompleteCount(0);
    setPendingCount(0);
    setVeryEasyCount(0);
    setEasyCount(0);
    setNeutralCount(0);
    setDifficultCount(0);
    setVeryDifficultCount(0);
  };

  const handleReset = () => {
    setDate1(today);
    setDate2(today);
    localStorage.clear();
    resetCounts();
  };

  useEffect(() => {
    const savedPositionName = localStorage.getItem("positionName");
    if (savedPositionName) setPositionName(savedPositionName);
    fetchCount();
  }, []);

  return (
    <div
      className="ctn-dashboard-css"
      style={{ display: "block", marginRight: "10%", overflow: "hidden" }}
    >
      <h4>Welcome {positionName}</h4>
      <h4>Filter Values:</h4>
      <div className="date-filter-container">
        <div>
          <label>Start Date:</label>
          <Calendar
            value={date1}
            onChange={(e) => {
              localStorage.setItem("date1", e.value)
              setDate1(e.value)}}
            dateFormat="dd/mm/yy"
            showIcon
          />
        </div>

        <div>
          <label>End Date:</label>
          <Calendar
            value={date2}
            onChange={(e) => {
              localStorage.setItem("date2", e.value)
              setDate2(e.value)}}
            dateFormat="dd/mm/yy"
            showIcon
          />
        </div>

        <button className="submit-btn" onClick={fetchCount}>
          Submit
        </button>
      </div>

      <div className="cards-container">
        <Card className="card-custom">
          <Card.Body>
            <Card.Title>Upload Count As On Date</Card.Title>
            <Card.Text className="card-text-custom">
              {loading ? "Loading..." : totalCount}
            </Card.Text>
            <Link
              to={`/counttable?type=upload-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
            >
              View Upload Details
            </Link>
          </Card.Body>
        </Card>

        <Card className="card-custom">
          <Card.Body>
            <Card.Title>Feedback Received As On Date</Card.Title>
            <Card.Text className="card-text-custom">
              {loading ? "Loading..." : completeCount}
            </Card.Text>
            <Link
              to={`/counttable?type=complete-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
            >
              View Feedback Details
            </Link>
          </Card.Body>
        </Card>

        <Card className="card-custom">
          <Card.Body>
            <Card.Title>No Feedback Received As On Date</Card.Title>
            <Card.Text className="card-text-custom">
              {loading ? "Loading..." : pendingCount}
            </Card.Text>
            <Link
              to={`/counttable?type=pending-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
            >
              View No Feedback Details
            </Link>
          </Card.Body>
        </Card>
      </div>

      <div className="categorycardsdiv">
        <Card style={{ ...cardStyle, backgroundColor: "lightgreen" }}>
          <Card.Body>
            <Card.Title> Very Easy Count</Card.Title>
            <Card.Text style={cardTextStyle}>
              {loading ? "Loading..." : veryEasyCount}
            </Card.Text>
            <Link
              to={`/counttable?type=very-easy-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              View Very Easy Count Details
            </Link>
          </Card.Body>
        </Card>

        <Card
          style={{ ...cardStyle, backgroundColor: "#228B22", color: "white" }}
        >
          <Card.Body>
            <Card.Title>Easy Count</Card.Title>
            <Card.Text style={cardTextStyle}>
              {loading ? "Loading..." : easyCount}
            </Card.Text>

            <Link
              to={`/counttable?type=easy-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              View Easy Count Details
            </Link>
          </Card.Body>
        </Card>

        <Card style={{ ...cardStyle, backgroundColor: "#FFD700" }}>
          <Card.Body>
            <Card.Title> Neutral Count</Card.Title>
            <Card.Text style={cardTextStyle}>
              {loading ? "Loading..." : neutralCount}
            </Card.Text>
            <Link
              to={`/counttable?type=neutral-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              View Neutral Count Details
            </Link>
          </Card.Body>
        </Card>

        <Card style={{ ...cardStyle, backgroundColor: "#ff6666" }}>
          <Card.Body>
            <Card.Title> Difficult Count</Card.Title>
            <Card.Text style={cardTextStyle}>
              {loading ? "Loading..." : difficultCount}
            </Card.Text>

            <Link
              to={`/counttable?type=difficult-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              View Difficult Details
            </Link>
          </Card.Body>
        </Card>

        <Card style={{ ...cardStyle, backgroundColor: "red", color: "white" }}>
          <Card.Body>
            <Card.Title> Very Difficult Count</Card.Title>
            <Card.Text style={cardTextStyle}>
              {loading ? "Loading..." : veryDifficultCount}
            </Card.Text>
            <Link
              to={`/counttable?type=very-difficult-list&date1=${
                date1 ? formatDate(date1) : ""
              }&date2=${
                date2 ? formatDate(new Date(date2.getTime() + 86400000)) : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              View Very Difficult Details
            </Link>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};
// Common Styles
const cardStyle = {
  width: "13rem",
  height: "15rem",
  backgroundColor: "#D3D3D3",
  border: "1px solid #D3D3D3",
  borderRadius: "0px",
  color: "black",
  textAlign: "center",
};

const cardTextStyle = {
  fontWeight: "bold",
  fontSize: "40px",
  padding: "5px 15px",
  color: "inherit",
};
